import React, { Component } from 'react';
import { connect } from 'react-redux';

import { getPermissions, getCompany, getSubcompany } from 'auth/selectors';
import ProjectsList from 'projects/components/list';

class ProjectsRowContainer extends Component {
  render = () => (
    <ProjectsList.Row
      handleToggle={this.props.handleToggle}
      company={this.props.company}
      subcompany={this.props.subcompany}
      project={this.props.project}
      permissions={this.props.permissions}
    />
  );
}

const mapStateToProps = (state) => ({
  company: getCompany(state),
  subcompany: getSubcompany(state),
  permissions: getPermissions(state),
});

export default connect(mapStateToProps, null)(ProjectsRowContainer);



// WEBPACK FOOTER //
// src/modules/secured/modules/projects/containers/ProjectsRowContainer.js